import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import { api } from "../../api";
import { crd, bdg } from "../../constants/styles";

function CCPage() {
  const { t, h, tens, pays, setPays, mts, ccs, setCcs, go, flash, setEditingCC, showConfirm } = useContext(Ctx);

  const deleteCC = async (id) => {
    showConfirm(t.deleteChargeConfirm, async () => {
      const cc = ccs.find(c => c.id === id);
      const mo = cc?.mo;
      await api.deleteCC(id);
      setCcs(ccs.filter(c => c.id !== id));
      if (mo) {
        // Zero `com` only for the tenants this charge applied to (its
        // property, or everyone for a building-wide charge) and PERSIST
        // it — previously every property's due rows were zeroed locally
        // only, so totals were wrong until the next sync while the
        // server kept charging the stale amount.
        const targetTids = cc?.property_id
          ? tens.filter(te => te.pid === cc.property_id).map(te => te.id)
          : tens.map(te => te.id);
        const up = pays.map(p =>
          (p.mo === mo && p.st === "due" && targetTids.includes(p.tid) && (p.com || 0) > 0)
            ? { ...p, com: 0 } : p);
        setPays(up);
        up.forEach(p => {
          if (p.mo === mo && p.st === "due" && targetTids.includes(p.tid) && p.com === 0) {
            const orig = pays.find(x => x.id === p.id);
            if (orig && (orig.com || 0) > 0) api.savePayment(p);
          }
        });
      }
      flash(t.deleted);
    });
  };

  return <div style={{ paddingTop: 16 }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}><h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: 0 }}>{t.common}</h2>
      <button onClick={() => { setEditingCC(null); go("ccForm"); }} style={{ background: h.ac, border: "none", color: "#fff", padding: "8px 14px", borderRadius: 10, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>{"+ " + t.add}</button></div>
    {ccs.map(c => <div key={c.id} style={crd(h)}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
        <div style={{ color: h.tx, fontWeight: 600, fontSize: 14 }}>{c.mo}</div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => { setEditingCC(c); go("ccForm"); }} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 16 }}>✏️</button>
          <button onClick={() => deleteCC(c.id)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 16 }}>🗑️</button>
        </div>
      </div>
      {c.items && c.items.length > 0 ? (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          {c.items.map((it, i) => (
            <div key={i} style={{ background: `${h.ac}10`, borderRadius: 10, padding: 10 }}><div style={{ color: h.sc, fontSize: 10, textTransform: "uppercase" }}>{it.name}</div><div style={{ color: h.tx, fontWeight: 700, fontSize: 16 }}>₹{Number(it.amount || 0).toLocaleString()}</div></div>
          ))}
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          <div style={{ background: `${h.ac}10`, borderRadius: 10, padding: 10 }}><div style={{ color: h.sc, fontSize: 10 }}>{t.eb}</div><div style={{ color: h.tx, fontWeight: 700, fontSize: 16 }}>₹{c.eb.toLocaleString()}</div></div>
          <div style={{ background: `${h.gn}10`, borderRadius: 10, padding: 10 }}><div style={{ color: h.sc, fontSize: 10 }}>{t.cleaning}</div><div style={{ color: h.tx, fontWeight: 700, fontSize: 16 }}>₹{c.cl.toLocaleString()}</div></div>
        </div>
      )}
      <div style={{ marginTop: 10, display: "flex", justifyContent: "space-between", padding: "8px 12px", background: `${h.ac}08`, borderRadius: 8 }}>
        <span style={{ color: h.sc, fontSize: 12 }}>{t.total}: ₹{(c.items && c.items.length > 0 ? c.items.reduce((s, it) => s + Number(it.amount || 0), 0) : c.eb + c.cl).toLocaleString()}</span>
        <span style={{ color: h.ac, fontSize: 12, fontWeight: 600 }}>{t.perTen}: ₹{(c.n > 0 ? Math.round((c.items && c.items.length > 0 ? c.items.reduce((s, it) => s + Number(it.amount || 0), 0) : c.eb + c.cl) / c.n) : 0).toLocaleString()}</span></div>
    </div>)}

    {(() => {
      const ptMts = mts.filter(m => m.exp_amt > 0 && m.exp_applied && m.exp_target !== "all");
      if (ptMts.length === 0) return null;
      return <div style={{ marginTop: 20 }}>
        <h3 style={{ color: h.tx, fontSize: 14, fontWeight: 700, marginBottom: 10 }}>{t.perTenantCharges} 🛠️</h3>
        {ptMts.map(m => {
          const teName = tens.find(x => x.id === m.exp_target)?.name || "?";
          return <div key={m.id} style={{ ...crd(h), borderLeft: `3px solid ${h.wn}`, padding: 14 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ color: h.tx, fontWeight: 600, fontSize: 13 }}>{m.desc}</div>
                <div style={{ color: h.sc, fontSize: 11, marginTop: 2 }}>{t.chargedTo}: <span style={{ color: h.wn, fontWeight: 600 }}>{teName}</span></div>
              </div>
              <div style={{ color: h.tx, fontWeight: 700, fontSize: 16 }}>₹{m.exp_amt.toLocaleString()}</div>
            </div>
            <div style={{ color: h.sc, fontSize: 10, marginTop: 4 }}>{m.dt} {m.exp_applied && <span style={{ color: h.gn }}>✓ {t.expAlreadyApplied}</span>}</div>
          </div>;
        })}
      </div>;
    })()}
  </div>;
}

export default CCPage;
